import { render } from "./Approved.vue?vue&type=template&id=5aae01a0&scoped=true"
import script from "./Approved.vue?vue&type=script&lang=js"
export * from "./Approved.vue?vue&type=script&lang=js"

import "./Approved.vue?vue&type=style&index=0&id=5aae01a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aae01a0"]])

export default __exports__